export function registerGtmDataLayer(obj) {
    // create datalayer if not exist
    window.dataLayer = ( typeof window.dataLayer != 'undefined' && window.dataLayer instanceof Array ) ? window.dataLayer : [];
    window.dataLayer.push(obj);
}